import { render, staticRenderFns } from "./uploadArquivosCliente.vue?vue&type=template&id=50e037e1"
import script from "./uploadArquivosCliente.vue?vue&type=script&lang=js"
export * from "./uploadArquivosCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports